export type MutableToggles = typeof defaultToggles;
export type Toggles = Readonly<MutableToggles>;
export type ToggleName = keyof Toggles;

export const defaultToggles = {
    EMERGENCY_DISABLE_TILELISTLITE: false,
    TILELIST_INITIALLY_VISIBLE: false,
    ENABLE_FEATURE_FUAG_COMPONENT_ON_TILE: false,
    DUMMY_TOGGLE: false,
    EXPERIMENT_DUMMY_ACTIVE: false,
    FEATURE_DUMMY_USE_GROUP_A: false,
    EXPERIMENT_DUMMY_N_GROUP_ACTIVE: false,
    FEATURE_DUMMY_N_GROUP_USE_GROUP_B: false,
    DA_KEEP_HEUREKA_SHEET_FRAGMENT: false,
    REPTILE_1522_ADDITIONAL_IMAGES_EXPERIMENT: false,
    REPTILE_1522_ADDITIONAL_IMAGES: false,
    REPTILE_1495_FORCE_INDEX: false,
    REPTILE_1564_BOOST_TEASER_VARIATIONS_EXPERIMENT: false,
    REPTILE_1564_BOOST_TEASER_VARIATIONS: false,
    EMERGENCY_DISABLE_OTTO_UP_PROMO: false,
    EMERGENCY_DISABLE_WATO_HOARDING: false,
    EMERGENCY_DISABLE_BENEFIT_CINEMA: false,
    REPTILE_1590_TWO_COLUMN_LANDSCAPE_EXPERIMENT: false,
    REPTILE_1590_TWO_COLUMN_LANDSCAPE: false,
    REPTILE_1537_BRAND_TILE_EXPERIMENT: false,
    REPTILE_1537_BRAND_TILE: false,
    REPTILE_1608_UVP_DISPLAY_EXPERIMENT: false,
    REPTILE_1608_UVP_DISPLAY: false,
    REPTILE_1610_CUTOUT_IMAGE_EXPERIMENT: false,
    REPTILE_1610_CUTOUT_IMAGE: false,
    REPTILE_1288_ARRANGEMENT_EXPERIMENT: false,
    REPTILE_1288_ARRANGEMENT: false,
    REPTILE_1614_CLEAN_TILE_V2_EXPERIMENT: false,
    REPTILE_1614_CLEAN_TILE_V2: false,
};
